import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { pageAction } from '../redux_files/actions/page_actions';

const Aboutus = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = 'About Us';
    dispatch(pageAction('About Us'));
  });
  return (
    <>
      <div className='container'>
        <div className='aboutus outer-border pd-20'>
          Welcome to Shivay Durga Foods!<br />
          We are a dedicated team passionate about bringing the authentic taste of home-cooked Indian meals to your table.
          With a focus on quality, hygiene, and taste, Shivay Durga Foods offers freshly prepared tiffin services and meals crafted with love and tradition.<br />
          Whether you are a student, a working professional, or someone away from home, we are here to provide nutritious, delicious, and affordable food every day.<br />
          At Shivay Durga, we believe food is not just about filling the stomach — it`s about satisfying the soul.<br /><br/>
          That`s why we source fresh ingredients daily and follow age-old recipes that make you feel at home, no matter where you are.
          <br />
          Our mission is to provide homemade food to people staying away from home and are compelled to eat Masale wala food. We will
          provide simple food to all at very low cost.
          <br />
          <br />
          This idea came to our mind when we visited some other city once for some work, there we struggled a lot to get simple homemade
          food and even after trying different restaurants we were unable to get simple food. Everyhere there were too much of spices and oil.
          <br />
          <br />
          Its been more than a year we have been serving you people, and thank your for all your support and love.
          <br />
        </div>
      </div>
    </>
  );
};

export default Aboutus;
